import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaseStudyOutcomeComponent } from './case-study-outcome.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { StarRatingModule } from '../../star-rating/star-rating.module';
import { CaseStudyRelationTableModule } from '../case-study-relation-table/case-study-relation-table.module';

@NgModule({
  declarations: [CaseStudyOutcomeComponent],
  imports: [CommonModule, SharedModule, StarRatingModule, CaseStudyRelationTableModule],
  exports: [CaseStudyOutcomeComponent],
})
export class CaseStudyOutcomeModule {}
